<template>
  <div
    style="
      width: 100%;
      height: 100%;
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    "
  >
    <slot>
      <img v-show="!imgHidden" src="~@/assets/product/image_搜索上限.png" alt="" />
      <div class="msg fontSize20">今日检索已到上限，注册账号获得更多检索机会</div>
      <Abbutton>
        <slot name="action-words"
          ><a
            href="https://crm.cnabke.com/#/passport/register"
            data-source="p"
            onmouseover="linkDataSource(this)"
            a-type="register"
            target="_blank"
            rel="noopener noreferrer"
            >立即注册</a
          ></slot
        >
      </Abbutton>
    </slot>
  </div>
</template>

<script>
import Abbutton from "@/components/Abbutton.vue";
export default {
  props: ["imgHidden"],
  components: {
    Abbutton,
  },
};
</script>

<style lang="sass" scoped>
  img{
    width: 455px;
    height: 460px;
  }
  .msg{
    padding-top: 24px;
    padding-bottom: 40px;
    // width: 414px;
    // height: 27px;
    font-family: Alibaba-PuHuiTi-R;
    font-weight: normal;
    color: #333646;
// line-height: 27px;
  }
  ::v-deep .ab-btn{
    width: 200px;
    height: 64px;
  }
</style>
